// @flow
export const handleShowMore = (e: Event) => {
  var self: HTMLElement = ((e.currentTarget: any) : HTMLElement);
  var parent: HTMLElement = ((self.parentElement: any): HTMLElement);
  var optsContainer: HTMLElement = ((parent.querySelector(".product-listing-filters__select-opt-container"): any): any);
  var opts = optsContainer ? optsContainer.children : null ;

  if (opts == null) return;

  var limitTo = parseInt(optsContainer.dataset.displayRowsLimit);
  if (opts.length <= limitTo) return;

  if (isShowingMore(self)) {
    // show less
    self.textContent = "Show more";

    const newOrderBy = optsContainer.dataset.showLessOrderBy;
    const newOrderDirection = optsContainer.dataset.showLessOrderDirection;
    reorder(optsContainer, newOrderBy, newOrderDirection);

    // hide above limit
    for (var i = limitTo; i < opts.length ;  i ++) {
      opts[i].classList.add('hide');
    }
  } else {
    // show more
    self.textContent = "Show less";

    const newOrderBy = optsContainer.dataset.showMoreOrderBy;
    const newOrderDirection = optsContainer.dataset.showMoreOrderDirection;
    reorder(optsContainer, newOrderBy, newOrderDirection);

    // show all
    for (var j = 0; j < opts.length ;  j ++) {
      opts[j].classList.remove('hide');
    }
  }
};

const isShowingMore = showMoreEle => showMoreEle.textContent.trim() === "Show less";

const reorder = (optsContainer, sortBy, sortDirection) => {
  if (!!sortBy && !!sortDirection) {
    const unselectedChildren = [...optsContainer.children].filter(ele => ele.dataset.selected === 'false');
    const unselectedChildrenNewOrder = unselectedChildren.sort((ele1, ele2) => {
      const val1 = ele1.dataset[sortBy];
      const val2 = ele2.dataset[sortBy];
      const valAsInt1 = parseInt(val1);
      const valAsInt2 = parseInt(val2);

      if (!!valAsInt1 && !!valAsInt2) {
        const compareResult = valAsInt1 - valAsInt2;
        return sortDirection === `asc` ? compareResult : -1*compareResult;
      } else {
        const compareResult = val1.localeCompare(val2);
        return sortDirection === `asc` ? compareResult : -1*compareResult;
      }
    });

    unselectedChildrenNewOrder.forEach(child => optsContainer.removeChild(child));
    unselectedChildrenNewOrder.forEach(child => optsContainer.appendChild(child));
  }
};



// WEBPACK FOOTER //
// ./javascript/product-search-page/raw-from-relab/plp-sidebar/productFilters/handleShowMore.js